import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getPerformance, trace } from "firebase/performance";
import firebaseConfig from "../firebase.config.json";

let appInstance = null;
let analyticsInstance = null;
let performanceInstance = null;

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function initFirebase() {
  if (analyticsInstance || performanceInstance) {
    return { app: appInstance, analytics: analyticsInstance, performance: performanceInstance };
  }

  if (!isBrowser()) {
    return {};
  }

  if (!firebaseConfig || !firebaseConfig.apiKey) {
    console.warn("Firebase config is missing. Analytics/Performance will be skipped.");
    return {};
  }

  appInstance = initializeApp(firebaseConfig);

  try {
    analyticsInstance = getAnalytics(appInstance);
  } catch (err) {
    console.warn("Firebase Analytics initialization failed:", err);
  }

  try {
    performanceInstance = getPerformance(appInstance);
  } catch (err) {
    console.warn("Firebase Performance initialization failed:", err);
  }

  return { app: appInstance, analytics: analyticsInstance, performance: performanceInstance };
}

export function trackContactResult(status, errorMessage = "") {
  const { analytics } = initFirebase();
  if (!analytics) return;

  const params = { status };
  if (errorMessage) {
    params.error = String(errorMessage).slice(0, 120);
  }

  logEvent(analytics, "contact_submit", params);
}

export function trackAppDownload(platform) {
  const { analytics } = initFirebase();
  if (!analytics) return;

  logEvent(analytics, "app_download", { platform });
}

export function startContactTrace() {
  const { performance } = initFirebase();
  if (!performance) return null;

  try {
    const perfTrace = trace(performance, "contact_request");
    perfTrace.start();
    return perfTrace;
  } catch (err) {
    console.warn("Firebase Performance trace failed to start:", err);
    return null;
  }
}
